import {createReducer} from "./utils/createReducer";
import {IUser} from "../../../type/user";
import {_CRUD} from "../action/_Action";
import {ACCOUNT_INFOS, ENTERPRISE_SELECTED, REFEST_AFTER_CHANGE_REQUEST, REFEST_AFTER_CHANGE_SUCCESS, REFEST_AFTER_CHANGE_FAILURE} from "src/core/redux/action/accountInfosAction";
import { ENTERPRISE_INFOS } from "../action/enterpriseInfosAction";

interface IAccountInfoState {
  isFetching: boolean;
  isUpdating: boolean;
  connectedUser: IUser | null;
  enterprises: any[] | null;
  enterpriseSelected: any | null;
  context: any | null;
}

const defaultState: IAccountInfoState = {
  isFetching: true,
  connectedUser: null,
  enterprises: null,
  enterpriseSelected: null,
  context: null,
  isUpdating: false
};

const actionToState = {
  request: (state, action) => ({
    ...state,
    isFetching: true
  }),
  success: (state, action) => ({
    ...state,
    isFetching: false,
    connectedUser: action.data.user,
    context: action.data.context,
    enterprises: action.data.enterprises || []
  }),
  failure: (state, action) => ({
    ...state,
    isFetching: false
  })
};

const update = {
  request: (state, action) => ({
    ...state,
    isUpdating: true
  }),
  success: (state, action) => {
    return {
      ...state,
      isUpdating: false,
      connectedUser: action.data
    }
  },
  failure: (state, action) => ({
    ...state,
    isUpdating: false
  })
};

const updateEnterpriseSelected = (state, action) => ({
  ...state,
  enterpriseSelected: state.enterprises.find(e => e.id === action.id) ,
})

const updateEnterpriseAfterEditInfoContractuel = (state, action) => ({
  ...state,
  enterpriseSelected: action.data ,
})

const refeshAfterChange = {
  request: (state, action) => ({
    ...state,
    isUpdating: true
  }),
  success: (state, action) => {
    return {
      ...state,
      isFetching: false,
      connectedUser: action.data.user,
      enterprises: action.data.enterprises || [],
      enterpriseSelected: action.data.enterprises.find(e => e.id === state.enterpriseSelected.id) ,
    }
  },
  failure: (state, action) => ({
    ...state,
    isUpdating: false
  })
}

export const accountInfoReducer = createReducer<IAccountInfoState>(defaultState, {
  [_CRUD(ACCOUNT_INFOS).GET.REQUEST]: actionToState.request,
  [_CRUD(ACCOUNT_INFOS).GET.SUCCESS]: actionToState.success,
  [_CRUD(ACCOUNT_INFOS).GET.FAILURE]: actionToState.failure,
  [_CRUD(ACCOUNT_INFOS).UPDATE.REQUEST]: update.request,
  [_CRUD(ACCOUNT_INFOS).UPDATE.SUCCESS]: update.success,
  [_CRUD(ACCOUNT_INFOS).UPDATE.FAILURE]: update.failure,
  [ENTERPRISE_SELECTED]: updateEnterpriseSelected,
  [_CRUD(ENTERPRISE_INFOS).UPDATE.SUCCESS]: updateEnterpriseAfterEditInfoContractuel,
  [REFEST_AFTER_CHANGE_REQUEST]: refeshAfterChange.request,
  [REFEST_AFTER_CHANGE_SUCCESS]: refeshAfterChange.success,
  [REFEST_AFTER_CHANGE_FAILURE]: refeshAfterChange.failure,
});



// WEBPACK FOOTER //
// ./src/core/redux/reducer/accountInfoReducer.ts